<template>
  <div :id="base.id"></div>
</template>

<script>
export default {
  name: "WechatLogin",
  props: ["config", "onLogin"],
  computed: {
    base: function() {
      return {
        id: this.config.id || "wxLoginContainer",
        src:
          this.config.src ||
          "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"
      };
    }
  },
  created() {
    if (
      window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
      "micromessenger"
    ) {
      window.location.href =
        "https://www.mools.net/lims/api/laravel/public/index.php/webapp/webAppLoginWxTwo?args=wx&baseurl=" +
        encodeURI(btoa(window.location.href));
      // // 微信浏览器
      // if (this.$route.query.code) {
      //   // 有code
      //   this.$emit("onLogin", this.$route.query.code, "wx");
      // } else {
      //   let currentUrl = window.location.href;
      //   currentUrl = currentUrl.replace("#/", "");
      //   currentUrl =
      //     currentUrl.indexOf("www.mools.net") != -1
      //       ? currentUrl
      //       : this.config.redirect_uri + "?callback=" + currentUrl;
      //   window.location.href =
      //     "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      //     this.config.wechatid +
      //     "&redirect_uri=" +
      //     encodeURI(currentUrl) +
      //     "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      // }
    } else {
      // 正常浏览器
      this.loadWxLogin(WxLogin => this.wechatLogin(WxLogin));
      window.addEventListener("message", e =>
        this.$emit("onLogin", e.data.code, "pc")
      );
    }
  },
  methods: {
    // 加载微信登录脚本
    loadWxLogin(callback) {
      if (window.WxLogin) {
        callback(window.WxLogin);
      } else {
        const wxJs = document.createElement("script");
        wxJs.type = "text/javascript";
        wxJs.src = this.base.src;
        wxJs.onload = () => {
          callback(window.WxLogin);
        };
        document.body.appendChild(wxJs);
      }
    },
    // 微信登录
    wechatLogin(WxLogin) {
      WxLogin({
        self_redirect: true,
        id: this.base.id,
        appid: this.config.appid,
        scope: "snsapi_login",
        redirect_uri: encodeURI(this.config.redirect_uri),
        state: "",
        style: "black",
        href: ""
      });
    }
  }
};
</script>
